<template>
<div>

</div>
</template>

<script>
export default {

  name: 'series-index',

  data () {
    return {

    }
  }
}
</script>


